export enum UserActionTypes {
  SET_USER_NAME = 'SET_USER_NAME',
  RESET_USER = 'RESET_USER',
}

export type SetUserNameAction = {
  type: UserActionTypes.SET_USER_NAME;
  payload: string;
};

export type ResetUserAction = {
  type: UserActionTypes.RESET_USER;
};

export type UserActions = SetUserNameAction | ResetUserAction;

export const setUserName = (userName: string): SetUserNameAction => ({
  type: UserActionTypes.SET_USER_NAME,
  payload: userName,
});

// Leaving this action creator for future use if we need to reset the user state on logout
export const resetUser = (): ResetUserAction => ({
  type: UserActionTypes.RESET_USER,
});

export default { setUserName, resetUser };
